define('OutSystems/ClientRuntime/Application',["require", "exports", "module", "tslib", "./ApplicationInfo", "./ClientInfo", "./Communication", "./CookiesManager", "./Database", "./DataTypes", "./Entities", "./ErrorHandling", "./Exceptions", "./FeedbackMessageService", "./Flow", "./Injector", "./Injector/KnownServices", "./Logger", "./modules/ClientVariables/LocalStorageClientVariablesService", "./modules/Database/IDatabase", "./modules/Database/IndexedDB/IndexedDBDatabase", "./modules/Database/IndexedDB/IndexedDBEntityService", "./modules/Database/WebSQL/WebSQLDatabase", "./modules/Database/WebSQL/WebSQLEntityService", "./modules/LocaleService/LocaleService", "./modules/LogTable/LogDatabaseStorage", "./modules/MappingWithDefault/MappingWithDefaultService", "./modules/PersistentKeyValue/PersistentKeyValueStorage", "./NativeApplicationInfo", "./NativeHelper", "./NativeHttp", "./NativeLogger", "./Navigation", "./Performance", "./RequireManager", "./RolesInfo", "./ScreenStateCache", "./Settings", "./StorageProvider", "./Transitions", "./VersionsManager"], function (require, exports, module, tslib_1, ApplicationInfo, ClientInfo_1, Communication, CookiesManager, Database_1, DataTypes_1, Entities_1, ErrorHandling, Exceptions, FeedbackMessageService, Flow, Injector_1, KnownServices_1, Logger, LocalStorageClientVariablesService_1, IDatabase_1, IndexedDBDatabase_1, IndexedDBEntityService_1, WebSQLDatabase_1, WebSQLEntityService_1, LocaleService_1, LogDatabaseStorage_1, MappingWithDefaultService_1, PersistentKeyValueStorage_1, NativeApplicationInfo_1, NativeHelper, NativeHttp, NativeLogger, Navigation, OSPerformance, RequireManager, RolesInfo, ScreenStateCache_1, Settings_1, StorageProvider_1, Transitions_1, VersionsManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Application = exports.ApplicationStorage = void 0;
    var APPLICATION_MODULE_NAME = "Application";
    var UPGRADE_REQUIRED_CSS_CLASS = "upgrade-required";
    var UPGRADE_SUCCESS_CSS_CLASS = "upgrade-success";
    var UPGRADE_ERROR_CSS_CLASS = "upgrade-error";
    exports.ApplicationStorage = {
        hasRenderedSplashInSession: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "HasRenderedSplashInSession", false),
        pendingUpgradeFeedback: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "PendingUpgradeFeedback"),
    };
    var Application = (function () {
        function Application() {
            this.showingSplashScreen = false;
            this.logDatabaseStorage = null;
        }
        Application.prototype.setApplicationDefinition = function (applicationDefinition) {
            ApplicationInfo.setApplicationDefinition(applicationDefinition);
            var databaseName = NativeHelper.isRunningOnNative()
                ?
                    applicationDefinition.environmentKey + "_" + applicationDefinition.applicationKey
                :
                    applicationDefinition.applicationName;
            ApplicationInfo.setDatabaseName(databaseName);
        };
        Application.prototype.initializeLogger = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var networkStatusChecker, postLogsFunction, nativeShellVersion, e_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            networkStatusChecker = Communication.NetworkStatus;
                            postLogsFunction = Communication.postLog;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            return [4, NativeHelper.ensureNativeReady()];
                        case 2:
                            _a.sent();
                            if (!NativeLogger.NetworkStatus.isOnline()) return [3, 4];
                            return [4, (0, NativeApplicationInfo_1.getNativeShellVersion)()];
                        case 3:
                            nativeShellVersion = _a.sent();
                            if ((0, NativeApplicationInfo_1.isVersionGreaterOrEqualTo)(nativeShellVersion, "2.7.3")) {
                                networkStatusChecker = NativeLogger.NetworkStatus;
                                postLogsFunction = NativeLogger.postLog;
                            }
                            _a.label = 4;
                        case 4: return [3, 6];
                        case 5:
                            e_1 = _a.sent();
                            return [3, 6];
                        case 6:
                            Logger.setNetworkStatusChecker(networkStatusChecker);
                            Logger.setPostLogsFunction(postLogsFunction);
                            Logger.enableFallbackStorage();
                            return [2];
                    }
                });
            });
        };
        Application.prototype.initializeCookiesManager = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var isNativeHttpPluginAvailable, nativeHttp;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, NativeHttp.isNativeHttpPluginAvailable()];
                        case 1:
                            isNativeHttpPluginAvailable = _a.sent();
                            if (!isNativeHttpPluginAvailable) return [3, 3];
                            return [4, NativeHttp.getNativeHttpPlugin()];
                        case 2:
                            nativeHttp = _a.sent();
                            CookiesManager.initialize(nativeHttp);
                            _a.label = 3;
                        case 3: return [2];
                    }
                });
            });
        };
        Application.prototype.initialize = function (applicationDefinition, initType, dateTimeFormat, numberFormat, executeRequiredScripts) {
            var _this = this;
            if (initType === void 0) { initType = 0; }
            OSPerformance.start("Application initialize");
            var logInitialization;
            var cookiesInitialization;
            return Flow.tryCatchFinally(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var userRolesInitialization, initDb, versionManagerDone, onVersionManagerDone, waitForVersionsManagerDone, waitForApplicationReadyEvent, versionManagerEventHandlers, success;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            Logger.trace(APPLICATION_MODULE_NAME, "Initializing Application");
                            cookiesInitialization = this.initializeCookiesManager();
                            logInitialization = this.initializeLogger();
                            this.setApplicationDefinition(applicationDefinition);
                            (0, StorageProvider_1.setDefaultStorageNamespace)(ApplicationInfo.getHomeModuleName());
                            Communication.initialize(ApplicationInfo.isDebugEnabled(), ApplicationInfo.getUserCookieName(), function (currentViewHasChanged, isAutoUpgradeDisabled) {
                                return _this.onNewVersionDetected(currentViewHasChanged, isAutoUpgradeDisabled);
                            });
                            RequireManager.setErrorHandler(function (error) {
                                if (VersionsManager_1.default.isUpgradingVersion && !Exceptions.isSystem(error)) {
                                    Logger.trace(APPLICATION_MODULE_NAME, "RequireJS error during upgrade, treating as an upgrade error.");
                                    VersionsManager_1.default.handleUpgradeError(error, 1);
                                    return;
                                }
                                _this.handleError(error);
                            });
                            ScreenStateCache_1.ScreenStateCache.clear();
                            (0, Transitions_1.setDefaultTransition)(ApplicationInfo.getDefaultTransition());
                            if (dateTimeFormat) {
                                DataTypes_1.Constants.FORMAT.dateTimeFormat = dateTimeFormat;
                            }
                            if (numberFormat) {
                                DataTypes_1.Constants.FORMAT.numberFormat = numberFormat;
                            }
                            return [4, cookiesInitialization];
                        case 1:
                            _a.sent();
                            return [4, logInitialization];
                        case 2:
                            _a.sent();
                            Injector_1.default.register(KnownServices_1.ServiceNames.ClientVariablesService, function () { return new LocalStorageClientVariablesService_1.default(applicationDefinition.userProviderName); });
                            if ((0, Settings_1.getEnvParams)().IndexedDBOffline && !NativeHelper.isRunningOnNative()) {
                                Injector_1.default.register(KnownServices_1.ServiceNames.EntityService, function () { return new IndexedDBEntityService_1.default(); });
                            }
                            else if ((0, Settings_1.getEnvParams)().UseNewWebSQLImpl && NativeHelper.isRunningOnNative()) {
                                Injector_1.default.register(KnownServices_1.ServiceNames.EntityService, function () { return new WebSQLEntityService_1.default(); });
                            }
                            Injector_1.default.register(KnownServices_1.ServiceNames.TranslationsService, function () { return new MappingWithDefaultService_1.default(); });
                            Injector_1.default.register(KnownServices_1.ServiceNames.LocaleService, function () { return new LocaleService_1.default(ApplicationInfo.getHomeModuleName()); });
                            if (initType === 1) {
                                return [2, true];
                            }
                            userRolesInitialization = RolesInfo.initializeRolesFromServer();
                            initDb = this.initializeDatabase();
                            versionManagerDone = false;
                            onVersionManagerDone = function () {
                                versionManagerDone = true;
                            };
                            waitForVersionsManagerDone = new Promise(function (resolve) {
                                if (versionManagerDone) {
                                    resolve();
                                }
                                else {
                                    var originalOnVersionManagerDone_1 = onVersionManagerDone;
                                    onVersionManagerDone = function () {
                                        originalOnVersionManagerDone_1();
                                        resolve();
                                    };
                                }
                            });
                            waitForApplicationReadyEvent = waitForVersionsManagerDone.then(function () {
                                return _this.triggerApplicationReadyEvent();
                            });
                            versionManagerEventHandlers = {
                                onVersionReady: function () {
                                    return initDb
                                        .then(function (db) { return _this.onDatabaseReady(db); })
                                        .then(function () { return waitForVersionsManagerDone; })
                                        .then(function () { return waitForApplicationReadyEvent; })
                                        .then(function () { return _this.onApplicationReady(); });
                                },
                                onUpgradeFinished: function (success, reason) { return _this.onUpgradeFinished(success, reason); },
                                onNewVersionDetected: function (currentViewHasChanged, isAutoUpgradeDisabled) {
                                    return _this.onNewVersionDetected(currentViewHasChanged, isAutoUpgradeDisabled);
                                },
                                onAppInfoReady: function (appInfo) { return _this.onAppInfoReady(appInfo); },
                            };
                            return [4, VersionsManager_1.default.initialize(initDb, versionManagerEventHandlers)];
                        case 3:
                            success = _a.sent();
                            if (!success) return [3, 7];
                            return [4, userRolesInitialization];
                        case 4:
                            _a.sent();
                            if (!executeRequiredScripts) return [3, 6];
                            return [4, executeRequiredScripts()];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6:
                            onVersionManagerDone();
                            _a.label = 7;
                        case 7: return [2, success];
                    }
                });
            }); }, function (e) {
                return Flow.tryFinally(function () {
                    return logInitialization;
                }, function () {
                    if (initType === 0) {
                        _this.handleError(e);
                    }
                    else {
                        throw e;
                    }
                });
            }, function () { return OSPerformance.end("Application initialize"); });
        };
        Application.prototype.triggerApplicationReadyEvent = function () {
            var _this = this;
            var homeModuleController = ApplicationInfo.getHomeModuleControllerName();
            if (!!homeModuleController) {
                Logger.trace(APPLICATION_MODULE_NAME, "Calling application ready event handler for " + ApplicationInfo.getHomeModuleName());
                return new Promise(function (resolve, reject) {
                    RequireManager.loadModule([homeModuleController], resolve, reject);
                })
                    .then(function (moduleController) {
                    return moduleController.default.fireApplicationReady();
                })
                    .catch(function (error) {
                    _this.handleError(error);
                });
            }
        };
        Application.prototype.initializeDatabase = function () {
            var _this = this;
            Logger.trace(APPLICATION_MODULE_NAME, "Initializing application database.");
            var initDb;
            var persistentKVStorage;
            var isWebApp = ApplicationInfo.isWebApplication();
            var isRunningOnNative = NativeHelper.isRunningOnNative();
            var useIndexedDB = (0, Settings_1.getEnvParams)().IndexedDBOffline;
            var useNewWebSQL = (0, Settings_1.getEnvParams)().UseNewWebSQLImpl;
            if (isWebApp || ApplicationInfo.getHomeModuleKey() === "28f21196-030a-4be2-8241-5a4888fb3ca5") {
                Logger.trace(APPLICATION_MODULE_NAME, "Initializing database mock for NativeAppBuilder.");
                initDb = Database_1.SqlDbProvider.mockDb(ApplicationInfo.getDatabaseName());
            }
            else if ((!isRunningOnNative && !useIndexedDB) || (isRunningOnNative && !useNewWebSQL)) {
                Logger.trace(APPLICATION_MODULE_NAME, "Initializing SQLite/WebSQL database service.");
                initDb = Database_1.SqlDbProvider.openDb(ApplicationInfo.getDatabaseName()).then(function (db) {
                    return db.testConnection().then(function () {
                        return db.executeTransaction(function (runner) {
                            return Entities_1.LogTable.initialize(runner, db)
                                .andThen(function (runner) {
                                return Entities_1.PersistentKeyValue.initialize(runner, db).andThen(function () {
                                    persistentKVStorage = Entities_1.PersistentKeyValue.storage;
                                });
                            })
                                .andThen(function (runner) { return Entities_1.webSQLStorageInstance.initMetamodel(runner); })
                                .andThen(function () { return db; });
                        });
                    });
                });
            }
            else {
                var newImplInitDb = void 0;
                if (isRunningOnNative) {
                    newImplInitDb = WebSQLDatabase_1.default.open(ApplicationInfo.getDatabaseName());
                }
                else {
                    ApplicationInfo.setDatabaseName("".concat(ApplicationInfo.getEnvironmentKey(), "-").concat(ApplicationInfo.getUserProviderName()));
                    newImplInitDb = IndexedDBDatabase_1.default.open(ApplicationInfo.getDatabaseName(), function () {
                        return _this.onNewVersionDetected(true);
                    });
                }
                initDb = newImplInitDb.then(function (db) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var entityService;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                Logger.trace(APPLICATION_MODULE_NAME, "Initializing log database storage");
                                this.logDatabaseStorage = new LogDatabaseStorage_1.default(db);
                                return [4, this.logDatabaseStorage.initialize()];
                            case 1:
                                _a.sent();
                                Logger.trace(APPLICATION_MODULE_NAME, "Initializing persistent key value storage");
                                persistentKVStorage = new PersistentKeyValueStorage_1.default(db);
                                Logger.trace(APPLICATION_MODULE_NAME, "Initializing entity service");
                                entityService = Injector_1.default.resolve(KnownServices_1.ServiceNames.EntityService);
                                entityService.setDatabase(db);
                                return [2, db];
                        }
                    });
                }); });
            }
            return initDb.then(function (db) {
                return RolesInfo.initialize(persistentKVStorage).then(function () {
                    Logger.trace(APPLICATION_MODULE_NAME, "Application database initialized successfuly.");
                    return db;
                });
            });
        };
        Application.prototype.onDatabaseReady = function (db) {
            if ((0, IDatabase_1.instanceOfIDatabase)(db)) {
                var dbService = Injector_1.default.resolve(KnownServices_1.ServiceNames.EntityService);
                dbService.setReady();
                if (this.logDatabaseStorage) {
                    Logger.setOfflineStorage(this.logDatabaseStorage);
                }
            }
            else {
                Entities_1.webSQLStorageInstance.initDb(db);
            }
            Logger.trace(APPLICATION_MODULE_NAME, "Database initialized successfully");
        };
        Application.prototype.onNewVersionDetected = function (currentViewHasChanged, isAutoUpgradeDisabled) {
            var _this = this;
            isAutoUpgradeDisabled =
                (isAutoUpgradeDisabled !== null && isAutoUpgradeDisabled !== void 0 ? isAutoUpgradeDisabled : VersionsManager_1.default.isAutoUpgradeDisabled) && NativeHelper.isRunningOnNative();
            Logger.trace(APPLICATION_MODULE_NAME, "New version detected, currentViewHasChanged = " + currentViewHasChanged);
            var useTimestamp = true;
            var appInfoCallback = function (newIndex) {
                useTimestamp = newIndex;
            };
            if (currentViewHasChanged) {
                this.disableDocument();
                var onClick = function () {
                    return Navigation.changeWindowLocation(Navigation.buildApplicationRelativeUrl(), useTimestamp, true);
                };
                var getMessage = function (provider) {
                    return provider.getApplicationUpgradeRequiredMessage(_this.canLoseDataInUpgrade());
                };
                this.showFeedbackMessage(getMessage, 2, UPGRADE_REQUIRED_CSS_CLASS, isAutoUpgradeDisabled ? null : onClick).then(function () { return FeedbackMessageService.setEnabled(false); });
            }
            if (isAutoUpgradeDisabled) {
                return Promise.resolve();
            }
            else {
                return VersionsManager_1.default.cacheResourcesInBackground(appInfoCallback);
            }
        };
        Application.prototype.onAppInfoReady = function (appInfo) {
            try {
                OSPerformance.start("Application onAppInfoReady");
                this.updateHasTracingEnabled(appInfo);
                this.updateApplicationDefaultTimeout(appInfo);
                this.updateApplicationInfo(appInfo);
                this.updateClientInfo();
                this.updateLoggerDetails();
            }
            finally {
                OSPerformance.end("Application onAppInfoReady");
            }
        };
        Application.prototype.updateHasTracingEnabled = function (appInfo) {
            Logger.setTracingEnabled(appInfo.data.hasTracingEnabled);
        };
        Application.prototype.updateApplicationDefaultTimeout = function (appInfo) {
            ApplicationInfo.setApplicationDefaultTimeout(appInfo.data.applicationDefaultTimeout);
        };
        Application.prototype.updateApplicationInfo = function (appInfo) {
            ApplicationInfo.setModules(appInfo.data.modules);
            ApplicationInfo.setClientEntitiesModules(appInfo.data.entityModuleNames);
        };
        Application.prototype.updateClientInfo = function () {
            NativeHelper.ensureNativeReady()
                .then(function () { return (0, ClientInfo_1.setClientInfo)(); })
                .catch(function (e) { return Logger.trace("", "Client info update failed: " + e); });
        };
        Application.prototype.updateLoggerDetails = function () {
            var isNative = NativeHelper.isRunningOnNative();
            Logger.setDeviceDetails(isNative);
        };
        Application.prototype.shouldRenderSplashScreen = function () {
            var homeModule = ApplicationInfo.getHomeModuleDefinition();
            return (homeModule.splashScreenName &&
                homeModule.splashScreenName.length > 0 &&
                !exports.ApplicationStorage.hasRenderedSplashInSession.get());
        };
        Application.prototype.disableDocument = function () {
            var backgroundBackdrop = document.createElement("div");
            backgroundBackdrop.classList.add("background-backdrop");
            document.body.classList.add("disable-scroll");
            document.body.appendChild(backgroundBackdrop);
        };
        Application.prototype.canLoseDataInUpgrade = function () {
            return document.getElementsByTagName("form").length > 0;
        };
        Application.prototype.onUpgradeFinished = function (success, failReason) {
            Logger.trace(APPLICATION_MODULE_NAME, "Upgrade " + (success ? "finished successfully" : "failed with reason: " + failReason));
            var feedback = { success: success, failReason: failReason };
            if (success && !this.isShowingSplashScreen) {
                this.showUpgradeFeedback(feedback);
            }
            else {
                exports.ApplicationStorage.pendingUpgradeFeedback.set(feedback);
            }
        };
        Application.prototype.waitForAppReady = function () {
            var _this = this;
            if (this.isReady) {
                return Promise.resolve(undefined);
            }
            if (!this.appReadyPromise) {
                this.appReadyPromise = new Promise(function (resolve) {
                    _this.onReady = function () { return resolve(); };
                });
            }
            return this.appReadyPromise;
        };
        Application.prototype.onApplicationReady = function () {
            Logger.trace(APPLICATION_MODULE_NAME, "Application ready");
            OSPerformance.end("Application ready");
            Logger.flushLogsToServerIfOnline();
            this.isReady = true;
            if (this.onReady) {
                this.onReady();
                this.onReady = null;
            }
        };
        Application.prototype.onBeforeNavigation = function (nextLocation, isBackNavigation) {
            return Navigation.onBeforeNavigate(nextLocation, isBackNavigation);
        };
        Application.prototype.onAfterNavigation = function () {
            if (this.isShowingSplashScreen ||
                Navigation.hasPendingReload() ||
                VersionsManager_1.default.pendingRollbackApplicationVersion) {
                return;
            }
            Logger.trace(APPLICATION_MODULE_NAME, "Navigated to: " + Navigation.getCurrentLocation().href);
            var pendingFeedback = exports.ApplicationStorage.pendingUpgradeFeedback.get();
            if (!pendingFeedback) {
                return;
            }
            this.showUpgradeFeedback(pendingFeedback);
            exports.ApplicationStorage.pendingUpgradeFeedback.remove();
        };
        Application.prototype.showUpgradeFeedback = function (feedback) {
            var getMessage;
            var feedbackType;
            var extraCssClass;
            if (feedback.success) {
                feedbackType = 0;
                getMessage = function (provider) { return provider.getApplicationUpgradeCompleteMessage(); };
                extraCssClass = UPGRADE_SUCCESS_CSS_CLASS;
            }
            else {
                feedbackType = 2;
                extraCssClass = UPGRADE_ERROR_CSS_CLASS;
                switch (feedback.failReason) {
                    case 1:
                        getMessage = function (provider) { return provider.getApplicationUpgradeFailedOnResourcesMessage(); };
                        break;
                    case 2:
                        getMessage = function (provider) { return provider.getApplicationUpgradeFailedOnDataModelMessage(); };
                        break;
                    default:
                        getMessage = function (provider) { return provider.getApplicationUpgradeFailedUnknownMessage(); };
                        break;
                }
            }
            this.showFeedbackMessage(getMessage, feedbackType, extraCssClass);
        };
        Application.prototype.showFeedbackMessage = function (getMessage, type, extraCssClasses, onClick) {
            if (extraCssClasses === void 0) { extraCssClasses = ""; }
            return new Promise(function (resolve) {
                var languageResourcesModuleName = ApplicationInfo.getHomeModuleLanguageResourcesName();
                RequireManager.loadModule([languageResourcesModuleName], function (messageProvider) {
                    var message = getMessage(messageProvider);
                    if (message) {
                        FeedbackMessageService.showFeedbackMessage(message, type, true, extraCssClasses, true, onClick);
                    }
                    resolve();
                });
            });
        };
        Object.defineProperty(Application.prototype, "isShowingSplashScreen", {
            get: function () {
                return this.showingSplashScreen;
            },
            set: function (showing) {
                if (showing) {
                    exports.ApplicationStorage.hasRenderedSplashInSession.set(true);
                }
                this.showingSplashScreen = showing;
            },
            enumerable: false,
            configurable: true
        });
        Application.prototype.handleError = function (error, callContext) {
            ErrorHandling.handleError(error, callContext);
        };
        Application.prototype.exit = function () {
            return NativeHelper.isRunningOnNative() ? NativeHelper.exitApp() : true;
        };
        Application.prototype.registerDefaultErrorHandler = function (globalExceptionHandler) {
            return Injector_1.default.register(KnownServices_1.ServiceNames.GlobalExceptionHandler, globalExceptionHandler);
        };
        return Application;
    }());
    exports.Application = Application;
    var Instance = new Application();
    exports.default = Instance;
    Navigation.VersionedURL.setUrlVersionProvider(VersionsManager_1.default.getVersionedUrl.bind(VersionsManager_1.default));
    Instance.default = Instance;
    Instance.ApplicationStorage = exports.ApplicationStorage;
    module.exports = Instance;
});
//# sourceMappingURL=Application.js.map;
